/**
 * Page Access Log API client.
 *
 * Sends batches of page-access entries to the shared fs-assistant FastAPI
 * logging service (POST /log-access) — see
 * fs-assistant/frontend/src/api/pageAccessLog.js for the source of this
 * pattern, and fs-assistant/backend/src/fastapi/routes/page_access_log.py
 * for the endpoint this site is reusing instead of running its own backend.
 */
import { LOG_ACCESS_ENDPOINT } from '../config/api';

export async function sendLogBatch(logs) {
  if (!logs || logs.length === 0) {
    return;
  }

  const response = await fetch(LOG_ACCESS_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ logs }),
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => 'Unknown error');
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
}
